<template>
    <div class="row">
        <div v-if="!loading" class="col-12">
            <MdFormsEntryListItem v-for="entry in entries" :key="entry.id" :date-format="dateFormat" :entry="entry"
                                  :form-id="formId" :form-load-error-text="formLoadErrorText" :language="language"
                                  :like-text="likeText" :login-text="loginText" :login-url="loginUrl" :mode="mode"
                                  :page-id="pageId" :reply-text="replyText" :send-text="sendText"
                                  :show-answers-text="showAnswersText" :show-reply="true" :website-id="websiteId"
                                  @reply="reply"></MdFormsEntryListItem>
        </div>
        <div v-else class="col-12">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <p v-if="entries.length === 0" class="col-12">
            {{ noCommentsText }} </p>
    </div>
</template>

<script>
import Axios from 'axios';
import MdFormsEntryListItem from './EntryListItem.vue';

export default {
    components: {MdFormsEntryListItem},
    props: {
        pageId: {
            type: String,
            required: true
        },
        formId: {
            type: String,
            required: true
        },
        dateFormat: {
            type: String
        },
        noCommentsText: {
            type: String,
            required: true
        },
        replyText: {
            type: String,
            required: true,
        },
        likeText: {
            type: String,
            required: true
        },
        showAnswersText: {
            type: String,
            required: true
        },
        websiteId: {
            type: String,
            required: true
        },
        formLoadErrorText: {
            type: String,
            required: true,
        },
        sendText: {
            type: String,
            required: true
        },
        language: {
            type: String,
            required: true
        },
        loginUrl: {
            type: String
        },
        loginText: {
            type: String,
            required: true
        },
        mode: {
            type: String,
            default: 'entry'
        }
    },
    data() {
        return {
            entries: [],
            loading: true
        };
    },
    beforeMount() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.loading = true;
            Axios.get(`/umbraco/mdforms/${this.mode}/search?formId=${this.formId}&pageId=${this.pageId}`).then(response => {
                this.entries = response.data.data;
                this.loading = false;
            }).catch(error => {
                this.loading = false;
            });
        },
        reply(id) {
            for (let i = 0; i < this.entries.length; i++) {
                let entryToUpdate = this.entries[i];
                entryToUpdate.reply = entryToUpdate.id === id ? true : false;
                this.$set(this.entries, i, entryToUpdate);
            }
        }
    }
}
</script>